import { render, staticRenderFns } from "./viewJUSTF.vue?vue&type=template&id=324e1a1b&scoped=true"
import script from "./viewJUSTF.vue?vue&type=script&lang=js"
export * from "./viewJUSTF.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "324e1a1b",
  null
  
)

export default component.exports